export { featureFlags, getFlagDefinition } from './flags';
export type {
  FeatureFlagKey,
  BooleanFlagKey,
  VariantFlagKey,
  VariantValuesFor,
} from './flags';

export {
  getFlagValue,
  getAllFlagValues,
  setFeatureFlags,
  clearAllFeatureFlags,
} from './cookies';

export { FeatureFlagsProvider, FeatureFlagsContext } from './FeatureFlagsProvider';
export type { FlagValues } from './FeatureFlagsProvider';

export { useFeatureFlag, useFeatureFlagVariant } from './useFeatureFlag';

export { flagSwitch } from './flagSwitch';

export {
  getFeatureFlags,
  isFeatureFlagEnabled,
  getFeatureFlagVariant,
} from './server';
